import React from 'react'
import NFTActivityList from '../../newComponents/NFTActivityList'
import { Helmet } from 'react-helmet'

export default function Activity() {
	return (
		<>
			<Helmet>
				<title>{"Activities - YetiSwap NFT Marketplace"}</title>
			</Helmet>
			<NFTActivityList />
		</>
	)
}
